import { getCurrentDate, getCurrentDateOfBelow } from "../../services/DateServices";

export const reportObj = {
    CustomerContract: "",
    VesselName: "",
    Dispatchport: "",
    BunkeredDate: "",
    Status: "",
    pdfFileName: "",
    SampleList: []
}
export const reportFilterFuel = {
    contract: "",
    vessel: "",
    bunkerPort: "",
    reportedFromDate: getCurrentDateOfBelow(90),
    reportedToDate: getCurrentDate(),
    sampledFromDate: "",
    sampledToDate: "",
    sampleNumber: "",
    reportType: "",
    statusType: ""
}
export const reportFilterLube = {
    vessel: '',
    equipmentName: "",
    equipmentMake: "",
    equipmentModel: "",
    reportedFromDate: getCurrentDateOfBelow(180),
    reportedToDate: getCurrentDate(),
    sampledFromDate: "",
    sampledToDate: "",
    reportType: "",
    statusType: ""
}
export const reportFilterTot = {
    transformer: "",
    location: "",
    contract: "",
    rating: "",
    voltage: "",
    reportedFromDate: getCurrentDateOfBelow(730),
    reportedToDate: getCurrentDate(),
    sampledFromDate: "",
    sampledToDate: "",
    statusType: "",
    sampleNumber: ""
}
export const equipmentList = {
    SampleId: "",
    Equipment: "",
    Make: "",
    Model: "",
    lobrand: "",
    status: "",
    reportDt: ""
}
export const LubeList = {
    ShipName: "",
    contractNumber: "",
    serviceType: "",
    pdfFileName: "",
    EquipmentList: "",
    reportDt:"",
    customerName:""
}